import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
    FormControl,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-add-device-manual',
    imports: [
        TranslocoModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatButtonModule,
    ],
    templateUrl: './add-device-manual.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './add-device-manual.component.scss'
})
export class AddDeviceManualComponent {
    imeiControl = new FormControl('', [
        Validators.pattern(new RegExp('^[0-9]{15}$')),
    ]);
    // imei = '';

    constructor(
        // @Inject(MAT_DIALOG_DATA) public data: any,
        public matDialogRef: MatDialogRef<AddDeviceManualComponent>
    ) {}

    ngOnInit(): void {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Save and close
     */
    close(): void {
        // Save the message as a draft

        // Close the dialog
        this.matDialogRef.close();
    }

    /**
     * Discard the message
     */
    discard(): void {}

    /**
     * Send the message
     */
    save(): void {
        this.matDialogRef.close(this.imeiControl.getRawValue());
    }
}
